import { render, staticRenderFns } from "./ReferidosEmprendedores.vue?vue&type=template&id=0507f6f3&scoped=true"
import script from "./ReferidosEmprendedores.vue?vue&type=script&lang=js"
export * from "./ReferidosEmprendedores.vue?vue&type=script&lang=js"
import style0 from "./ReferidosEmprendedores.vue?vue&type=style&index=0&id=0507f6f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0507f6f3",
  null
  
)

export default component.exports